import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FoodProfileCard = ({ food }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all">
      {/* Header - Always Visible */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-6 flex items-center justify-between text-left hover:bg-slate-50 transition-colors rounded-xl"
      >
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-slate-900 mb-1">
            {food.name}
          </h3>
          <span className="inline-block px-3 py-1 bg-blue-50 text-blue-700 text-sm font-medium rounded-full">
            {food.category}
          </span>
        </div>
        <div className="ml-4">
          {isExpanded ? (
            <ChevronUp className="h-6 w-6 text-slate-400" />
          ) : (
            <ChevronDown className="h-6 w-6 text-slate-400" />
          )}
        </div>
      </button>

      {/* Expanded Content */}
      {isExpanded && (
        <div className="px-6 pb-6 space-y-6 border-t border-slate-100 pt-6">
          {/* Why People Include This Food */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              Why People Include This Food
            </h4>
            <p className="text-slate-700 leading-relaxed">
              {food.whyIncluded}
            </p>
          </div>

          {/* Key Nutrients */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              Key Nutrients
            </h4>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {food.keyNutrients.map((nutrient, index) => (
                <li
                  key={index}
                  className="flex items-center text-sm text-slate-700"
                >
                  <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                  {nutrient}
                </li>
              ))}
            </ul>
          </div>

          {/* Preparation Notes */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              Preparation Notes
            </h4>
            <p className="text-slate-700 leading-relaxed">
              {food.preparation}
            </p>
          </div>

          {/* Cautions & Notes */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
              Cautions & Notes
            </h4>
            <p className="text-slate-700 leading-relaxed">
              {food.cautions}
            </p>
          </div>

          {/* Disclaimer */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-xs text-slate-700 leading-relaxed">
              This information is provided for educational purposes only and does not constitute medical advice. Individual tolerance varies. Always consult your healthcare provider before making dietary changes.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FoodProfileCard;
